import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/common/http';

class CacheCountryListService {
    constructor(http) {
        this.http = http;
        this.countryDataSource = new BehaviorSubject({ listCountries: [] });
    }
    getCountry() {
        return this.http.get('/countries').pipe(map((response) => {
            if (response.data) {
                this.countryDataSource.next({ listCountries: response.data });
                return response.data;
            }
        }));
    }
    getCountryWithoutUSA() {
        return this.http.get('/countriesNonUsa').pipe(map((response) => {
            if (response.data) {
                return response.data;
            }
        }));
    }
    getCachedCountryList() {
        return this.countryDataSource.asObservable();
    }
}
CacheCountryListService.ɵfac = function CacheCountryListService_Factory(t) { return new (t || CacheCountryListService)(i0.ɵɵinject(i1.HttpClient)); };
CacheCountryListService.ɵprov = i0.ɵɵdefineInjectable({ token: CacheCountryListService, factory: CacheCountryListService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CacheCountryListService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

/*
 * Public API Surface of cache-country-list
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CacheCountryListService };
//# sourceMappingURL=cache-country-list.js.map
